import { Outlet } from 'react-router-dom';
import AppSidebar from './components/AppSidebar';
import AppNavbar from './components/AppNavbar';
import AppFooter from './components/AppFooter';

function AppLayout() {
  return (
    <>
      <div className="hidden lg:flex bg-grayscale-800">
        <AppSidebar />

        <div
          className="flex flex-col w-full h-screen overflow-y-auto bg-grayscale-900 no-scrollbar"
          id="app-layout-main"
        >
          <AppNavbar />

          <main className="pb-[99px] pr-[61px] pl-[67px] flex-1 w-full">
            <Outlet />
          </main>

          <AppFooter />
        </div>
      </div>

      <div className="flex flex-col items-center justify-center h-full px-4 lg:hidden">
        {/* <IconSvg icon="mobileToDesktop" /> */}

        <p className="font-linear-sans mt-5 text-[22px] text-black font-semibold">
          Sorry, for a better experience, we kindly ask you to use a desktop or laptop device.
        </p>
      </div>
    </>
  );
}

export default AppLayout;